<template>
<div>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-xs="12">
      <vs-card>
        <h2 class="card-title d-flex">{{$t('SPECIALDISCOUNT.HEADER.TITEL')}}
          <div class="ml-auto text-right">
            <vs-button  @click="LoadData()" size="small" color="primary" type="filled" icon="refresh"></vs-button>
          </div>
        </h2>
        <p class="card-subtitle">
          <span>{{$t('SPECIALDISCOUNT.HEADER.TEXT')}}</span>
        </p>
        <AddSpecialDiscountDlg ref="addSpecialDiscountDlg" v-on:Success="LoadData"></AddSpecialDiscountDlg>
      </vs-card>
    </vs-col>
  </vs-row>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
      <vs-card >
            <div class="d-flex align-items-center">
              <vs-button class="mt-3 mb-2"  type="filled" icon="add" @click="AddSpecialDiscount">{{$t('SPECIALDISCOUNT.ADD')}}</vs-button>
            </div> 
            <div id="specialdiscounts_table" class="vs-con-loading__container" >
              <vs-table
                search
                :data="specialdiscounts"
                :noDataText="$t('SPECIALDISCOUNT.NO_DATA')"
                stripe
                max-items="25" 
                pagination
                hoverFlat>

                <template slot="header">
                  <h3>
                    {{$t('SPECIALDISCOUNT.TABLE.HEADER')}}
                  </h3>
                </template>
                <template slot="thead">                               
                  <vs-th sort-key="name">
                    {{$t('SPECIALDISCOUNT.TABLE.COL1')}}
                  </vs-th>
                  <vs-th sort-key="discount_value">
                    {{$t('SPECIALDISCOUNT.TABLE.COL2')}}
                  </vs-th>                                                                                                     
                  <vs-th></vs-th>                                                                                                                                             
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr"  :key="indextr" v-for="(tr, indextr) in data" >                   
                    <vs-td :data="tr.name">
                      {{tr.name}}
                    </vs-td>     
                    <vs-td :data="tr.discount_value">
                      {{tr.discount_value}}%
                    </vs-td>                                                                                            
                    <vs-td>
                      <vs-button  @click="EditSpecialDiscount(tr)" class="ml-2" size="small" color="primary" type="filled" icon="edit"></vs-button>  
                      <vs-button  @click="OpenConfirmDeleteSpecialDiscount(tr.id,tr.name)" class="ml-2" size="small" color="primary" type="filled" icon="delete"></vs-button>                        
                    </vs-td>                    
                                                                                                                                                                                              
                  </vs-tr>
                </template>
              </vs-table>
            </div>           
        </vs-card>
      </vs-col>
  </vs-row>

</div>
</template>

<script>

import helperMethods from '../helper/staticFuncHelper';
import enumHelper from '../helper/enumHelper';
import codeHelper from '../helper/staticCodeHelper';
import AddSpecialDiscountDlg from './components/dialogs/AddSpecialDiscountDlg.vue';

export default {
  name: "SpecialDiscounts",
  components: {
    AddSpecialDiscountDlg
  },
    data: function (){
      return {
      specialdiscounts:[]
      };
  },
  mounted () {
      this.LoadData();
    },
  computed: 
  { 
    getTableData() {
      var data = [];
      if(this.$store.state.specialdiscount.specialdiscounts.data != null)
      {
        data = this.$store.state.specialdiscount.specialdiscounts.data
      }
      return data;
    },
    loadingTableData () {
      var loading = false;
      if(typeof(this.$store.state.specialdiscount.specialdiscounts.status) != 'undefined')
        loading = this.$store.state.specialdiscount.specialdiscounts.status.loading;
      return loading;
    }
  },
  watch: {
      getTableData(value) {
          this.specialdiscounts = value;
      },
      loadingTableData(value)
      {
        if(value)
        {
          this.$store.dispatch('alertqueue/showLoader', {'id':'#specialdiscounts_table'});
        }
        else
        {
          this.$store.dispatch('alertqueue/hideLoader', {'id':'#specialdiscounts_table'});
        }
      },
    },
  methods: {    
      ...helperMethods,
      ...enumHelper,
      ...codeHelper,
      LoadData: function ()
      {
          this.$store.dispatch('specialdiscount/getSpecialDiscounts', { root: true },{ root: true }); 
      },
      EditSpecialDiscount(data){
        this.$refs.addSpecialDiscountDlg.InitDlgData(data);
      },
      AddSpecialDiscount(){
        this.$refs.addSpecialDiscountDlg.ShowDlg();
      },  
      OpenConfirmDeleteSpecialDiscount(id,name) {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: this.$t('COM.SURE.TITEL'),
          acceptText: this.$t('COM.DELETE'),
          cancelText:this.$t('COM.CANCEL'),
          text: this.$t('SPECIALDISCOUNT.QUESTION.DELETE').replace("*1*",name),
          accept: this.SendDeleteRequest,
          parameters:{"id": id,"name": name}
        });
      
      },
      SendDeleteRequest: function(parameters)
      {
        this.$store.dispatch('specialdiscount/deleteSpecialDiscount', parameters.id)
        .then(response => {
          if(response.success == true)
          {
            this.LoadData();
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('SPECIALDISCOUNT.SUCCESS.DELETE').replace("*1*",parameters.name)});  
          }
          else
          {
            var text = this.$t('SPECIALDISCOUNT.WARNING.DELETE').replace("*1*",parameters.name);
            text = text.replace("*2*",this.$t(response.text));
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
          }
        }, 
        error =>{

            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('SPECIALDISCOUNT.ERROR.DELETE').replace("*1*",error)});  
        });
      }
  }
};

</script>